function Footer() {
  return (
    <footer className="w-full bg-gray-900 text-white text-center py-6 fixed bottom-0 left-0">
      <div className="flex flex-col md:flex-row justify-center items-center text-sm gap-4">
        <p>© 2025 Build Pro Resume. All rights reserved.</p>
        <a href="/disclaimer" className="hover:underline">
          Disclaimer
        </a>
        <a href="/privacy-policy" className="hover:underline">
          Privacy Policy
        </a>
        <a href="/terms" className="hover:underline">
          Terms & Conditions
        </a>
      </div>
    </footer>
  );
}

export default Footer;
